import React from "react";

import { useGetVerificationEditingRequests } from "utils";

import { EDITING_REQUEST_TYPE, PRACTICE_SLUG, VerificationEditingRequest } from "models";

import { Flex, Row } from "components";

import { PracticeList } from "pages/admin/verifications/components/lists/PracticeList";
import { EditingRequestInsightCards } from "pages/admin/verifications/components/misc/EditingRequestInsightCards";
import { FertilizerTable } from "pages/admin/verifications/components/misc/FertilizerTable";
import { FertilizerTimeline } from "pages/admin/verifications/components/misc/FertilizerTimeline";

export const FertilizerList = ({ farmId, onUpdate }: { farmId: string; onUpdate?: () => void }) => {
  const { data: editingRequests, isLoading: isLoadingEditingRequests } = useGetVerificationEditingRequests({ farmId, isAdmin: true });

  // Helper function to get editing requests for a specific field
  const getFieldEditingRequests = (fieldId: string): VerificationEditingRequest[] => editingRequests?.filter((request) => request.fieldId === fieldId) ?? [];

  return (
    <Flex vertical gap="2rem">
      <Row className="padding-bottom-200">
        {/* prelint-ignore-col */}
        {/* Cols are inside component */}
        <EditingRequestInsightCards
          loading={isLoadingEditingRequests}
          editingRequests={editingRequests ?? []}
          requestTypes={[EDITING_REQUEST_TYPE.MINERAL_FERTILIZER, EDITING_REQUEST_TYPE.ORGANIC_FERTILIZER]}
        />
      </Row>

      <PracticeList
        farmId={farmId}
        practiceSlugs={[PRACTICE_SLUG.MINERAL_FERTILIZERS, PRACTICE_SLUG.ORGANIC_FERTILIZERS]}
        onUpdate={onUpdate}
        renderTimeline={(fieldId) => <FertilizerTimeline fieldId={fieldId} />}
        renderExpandedContent={(field) => <FertilizerTable field={field} farmId={farmId} editingRequests={getFieldEditingRequests(field.id)} />}
        additionalDrawerProps={{
          editingRequests: editingRequests ?? [],
        }}
      />
    </Flex>
  );
};
